import { useState, useEffect } from 'react';
import BordLogo from '../../../../assets/images/services/bordLogo.svg';
import './QRcard.scss';

interface IQRData {
  serial: string;
  orgName: string;
  productId: string;
}

export interface IQrCard {
  qrData: IQRData;
  qrCode?: string;
}

const QRcard = ({ qrData, qrCode }: IQrCard) => {
  const [logoLoaded, setLogoLoaded] = useState(false);

  const preloadImage = (imageSrc: string, onLoadCallback: () => void) => {
    const img = new Image();
    img.onload = onLoadCallback;
    img.src = imageSrc;
  };

  useEffect(() => {
    preloadImage(BordLogo, () => setLogoLoaded(true));
  }, []);

  if (!qrCode) {
    return null;
  }
  
  return (
    <div className="qrCardContainer">
      <div className="printableTicketContainer">
        <div className="logoContainer">
          <img 
            src={BordLogo} 
            alt="Bord Logo" 
            style={{ visibility: logoLoaded ? 'visible' : 'hidden' }}
          />
        </div>
        <div className="qrCodeContainer" dangerouslySetInnerHTML={{ __html: qrCode?.trim() ?? '' }} />
        <div className="printableTicketInfoContainer">
          <div className="serialText">
            Serial: <strong>{qrData?.serial || 'N/A'}</strong>
          </div>
          <div className="spaceConatiner">
            <div className="grayLine" />
          </div>
          <div className="printableTicketInfoText">
            Empresa: <strong>{qrData?.orgName || 'N/A'}</strong>
          </div>
          <div className="printableTicketInfoText">
            Product ID: <strong>{qrData?.productId || 'N/A'}</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRcard;
